"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTACH_PRODUCT_TREE_TO_CATALOG = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.ATTACH_PRODUCT_TREE_TO_CATALOG = (0, gql_1.gql)(`
  mutation attachProductTreeToCatalog($catalogId: ID!, $productTreeId: ID!) {
    editProductTree(productTree: {
      id: $productTreeId,
      addCatalogs: [$catalogId],
      clientMutationId: "",
    }) {
      success
      error
      productTree {
        id
        title
        myPermissions
        tags {
          edges {
            node {
              id
              key
              value
            }
          }
        }
        root {
          id
          title
        }
      }
    }
  }
`);
